export default function FormTextarea({ label, value, onChange, placeholder = "" }) {
    return (
        <div className="wg-form-group full">
            <label className="wg-label">{label}</label>
            <textarea
                className="wg-textarea"
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
            />
        </div>
    );
}